import * as React from "react";
import { Button } from "@mui/material";
import { ConfirmationDialogWithTrigger } from "../../../Components/ConfirmationDialogWithTrigger";
import { Delete } from "@mui/icons-material";
import { useModal } from "../../../../hooks/use_modal";
import { deleteAutomation } from "../../../../stores/automations";
import { IAutomation } from "../../../../config/automation";

interface IDeleteActionProps {
    onDelete(): void;
    value: IAutomation;
}

export const DeleteAction = ({value, onDelete}: IDeleteActionProps) => {
    const { loading, setLoading } = useModal();

    const handleSubmit = (closeDialog: any) => () => {
        setLoading(true);
        deleteAutomation(value.id).then(() => {
            setLoading(false);
            onDelete();
            closeDialog();    
        })
    };

    return (
        <ConfirmationDialogWithTrigger
            loading={loading}
            title="Delete automation"
            description={<>
                Are you sure you wanna delete this automation?<br/>
                <strong>The operation cannot be undone.</strong>
            </>}
            icon={<Delete />}
            actions={({closeDialog}) => (
                [
                    <Button onClick={handleSubmit(closeDialog)} color="error" autoFocus key="yes">
                        Yes
                    </Button>,
                ]
            )}
        />
    )
};
